import { ListViewItem } from '@ingka/list-view';
import { translate } from '@repo/phrase';
import { getOrderHistory } from '@repo/utils';

import { Feature } from '@/components/feature';

import { useAssetParams } from '@/hooks/asset.hooks';

import type { AssetActionProps } from '../../asset-context-buttons.types';

const AssetOrderHistoryListItem = ({ onClose, context }: AssetActionProps) => {
    const { assetId } = useAssetParams();
    const orderHistory = getOrderHistory();

    if (!orderHistory?.open) {
        return null;
    }

    return (
        <Feature configPath={['orderHistory.enable']}>
            <ListViewItem
                title={translate('order_status_header_history')}
                control="navigational"
                controlIcon={context === 'modal' ? 'chevronRight' : null}
                inset={context === 'dropdown'}
                emphasised={context === 'modal'}
                onClick={() => {
                    orderHistory.open?.(assetId);
                    onClose?.();
                }}
            />
        </Feature>
    );
};

export const AssetOrderHistoryAction = ({ type, ...props }: AssetActionProps) => {
    if (type === 'button') {
        return null;
    }
    return <AssetOrderHistoryListItem key="order-history-list-item" {...props} />;
};
